// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__QW8xs","title":"BackImages_title__2cEvf","images":"BackImages_images__1NUCQ"};